/* DON'T EDIT THIS FILE: edit original and run build again */ export const marketplacePathCommon = "/marketplace";
export const marketplaceSgrReportsPath = "/marketplace/informes-sgrs";
